import { useReplyTemplatesStore } from "~/projects/help-desk/stores/replyStore";
import {
  useInboxStore,
  ticketsCache,
  conversationsCache,
} from "~/projects/help-desk/stores/inboxStore";
import { ElMessageBox, ElNotification } from "element-plus";
import { useHistoriesStore } from "~/projects/help-desk/stores/historiesStore";
import { TicketStatus, TicketSourceType } from "~/projects/help-desk/types";
import { useAuthStore } from "~/stores/auth";
import { useDialogStore } from "~/projects/cc/stores/dialogStore";
import { ShortcutKeyMap } from "~/projects/cc/types/enums/shortcutKeyMap";

const inboxStore = useInboxStore();
const dialogStore = useDialogStore();
const replyTemplatesStore = useReplyTemplatesStore();
const event = useNuxtApp().$event;
const historiesStore = useHistoriesStore();
const router = useRouter();
const route = useRoute();

const authStore = useAuthStore();

export default function (event: KeyboardEvent) {
  const isAltKey = event.altKey;
  const code = event.code;
  if (!isAltKey && code !== ShortcutKeyMap.KeyEsc) return;
  switch (code) {
    case ShortcutKeyMap.KeyI:
      handleShowDialer(true);
      break;
    case ShortcutKeyMap.KeyEsc:
      handleShowDialer(false);
      break;
    case ShortcutKeyMap.KeyC:
      handleMakeCall();
      break;
    case ShortcutKeyMap.KeyU:
      inboxStore.setShowUploadDialogVisibility(true);
      break;
    case ShortcutKeyMap.KeyG:
      inboxStore.setGalleryModalVIsibility(true);
      break;
    case ShortcutKeyMap.KeyR:
      changeTicketStatus(TicketStatus.SOLVED);
      break;
    case ShortcutKeyMap.KeyA:
      handleAcceptCall();
      break;
    case ShortcutKeyMap.KeyH:
      if (dialogStore._showOngoingCallDialog) {
        handleHoldCall();
      } else {
        setHistoryModal();
      }

      break;
    case ShortcutKeyMap.KeyT:
      if (dialogStore._showOngoingCallDialog) {
        handleAddTask();
      } else {
        replyTemplatesStore.getTemplates();
        replyTemplatesStore.setTemplatesListDialogVisibility(true);
      }
      break;
    case ShortcutKeyMap.KeyN:
      handleAddNote();
      break;
    case ShortcutKeyMap.KeyW:
      dialogStore.setShortcutListVisibility(true);
      break;
    default:
      break;
  }
}
const setHistoryModal = async () => {
  await historiesStore.getResolvedTicketHistory(
    inboxStore.selectedTicket.owner_id,
  );
  inboxStore.setShowHistoryModalVisibility(true);
};
const changeTicketStatus = async function (status: TicketStatus) {
  const { agent_id, other_ticket } = route.query;
  const selectedTicket = inboxStore._selectedTicket;
  const { error } =
    status === TicketStatus.OPEN
      ? await inboxStore.pick()
      : await inboxStore.resolve();

  if (error) {
    ElMessageBox({
      type: "error",
      title: "Ticket Status Change Failed",
      message: error.response?.data?.message || error.message,
    });
    return;
  }
  router.replace({
    path: route.path,
    query: {},
  });
  if (status === TicketStatus.SOLVED) {
    inboxStore.removeSelectedTicket();
    inboxStore.resetSelectedTicket();
    if (ticketsCache.has(selectedTicket.id)) {
      ticketsCache.remove(selectedTicket.id);
    }
    if (conversationsCache.has(selectedTicket.id)) {
      conversationsCache.remove(selectedTicket.id);
    }
    console.log("reseting selecting ticket");
  }
  if (
    selectedTicket.agent_id === authStore.user.id &&
    status !== TicketStatus.SOLVED
  ) {
    if (ticketsCache.has(selectedTicket.id)) {
      ticketsCache.remove(selectedTicket.id);
    }
    if (conversationsCache.has(selectedTicket.id)) {
      conversationsCache.remove(selectedTicket.id);
    }
    inboxStore.setSelectedTicket(selectedTicket.id);
    console.log("setting selected ticket");
  }
};
const handleShowDialer = function (val: boolean) {
  dialogStore.setDialerVisibility(val);
};

const handleMakeCall = function () {
  event("call");
};

// const handleRejectCall = function () {
//   event("reject");
// };

const handleAcceptCall = function () {
  event("accept");
};
const handleHoldCall = function () {
  event("hold");
};
const handleAddTask = function () {
  event("add_task");
};
const handleAddNote = function () {
  event("add_note");
};
